import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen px-4 py-10 bg-gray-50 sm:px-6 sm:py-16">
      <section className="max-w-4xl p-6 mx-auto bg-white shadow-lg rounded-xl sm:p-12">
        <h1 className="mb-6 text-4xl font-bold text-center sm:text-5xl font-heading text-navy-900">Our Story</h1>
        <p className="mb-6 text-lg text-center text-gray-700 sm:text-xl">
          Blessed Gideon Charity is dedicated to transforming lives and communities through compassionate action and sustainable development. We focus on providing essential resources, education, and support to those who need it most.
        </p>
        <p className="mb-4 text-base text-black sm:text-lg">
          Our mission is to empower vulnerable populations by addressing immediate needs while building long-term solutions. We work directly with communities to provide food security, clean water access, healthcare support, and educational opportunities that create lasting change.
        </p>
        <p className="mb-4 text-base text-gray-600 sm:text-lg">
          Through partnerships with local organizations and the dedication of our volunteers, we implement programs that strengthen families, support orphaned children, and develop community infrastructure. Every project is designed with sustainability and community ownership in mind.
        </p>
        <p className="text-base text-gray-600 sm:text-lg">
          Join us in our mission to create hope, restore dignity, and build brighter futures. Together, we can make a meaningful difference in the lives of those who need it most.
        </p>
      </section>
    </div>
  );
};

export default About;
